import React, { Component, Fragment } from 'react'
import { action, computed, observable, reaction } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import { DIRECTION_CUSTOMS } from '../stores/QueryParamsStore'
import withAppStore from 'decorators/withAppStore'
import styles from 'shared/styles/components/Datepicker'
import { Dialog, List, ListItem, ListItemText } from 'material-ui'
import { Typography } from 'material-ui'

@withStyles(styles)
@withAppStore
@observer
export default class Direction extends Component {
  constructor(params) {
    super(params)
    this.state = {
      direction: this.props.direction,
    }
    this.handleListItemClick = this.handleListItemClick.bind(this)
    this.options = Object.keys(DIRECTION_CUSTOMS).map((key, index) => {
      return {
        key: String(index),
        value:
          DIRECTION_CUSTOMS[key] === DIRECTION_CUSTOMS.EXPORT
            ? ' Экспорт '
            : DIRECTION_CUSTOMS[key] === DIRECTION_CUSTOMS.IMPORT
            ? ' Импорт '
            : ' Все режимы',
      }
    })
  }

  componentWillMount() {
    reaction(
      () => {
        const { direction } = this.appStore
        return { direction }
      },
      ({ direction }) => {
        this.setState({
          direction: direction,
        })
      },
    )
  }

  handleListItemClick = (item) => {
    this.setState({
      direction: item.key,
    })
    this.appStore.direction = item.key
    this.handleClose()
  }

  @observable isOpen = false

  @computed
  get direction() {
    return this.appStore.direction
  }
  set direction(value) {
    this.appStore.direction = value
  }

  @action.bound
  handleOpen() {
    this.isOpen = true
  }

  @action.bound
  handleClose() {
    this.isOpen = false
  }

  @computed
  get label() {
    const { isMobile } = this.props
    return this.state.direction === DIRECTION_CUSTOMS.EXPORT
      ? isMobile
        ? 'ЭК'
        : 'Экспорт'
      : this.state.direction === DIRECTION_CUSTOMS.IMPORT
      ? isMobile
        ? 'ИМ'
        : 'Импорт'
      : isMobile
      ? 'Все'
      : 'Все режимы'
  }

  render() {
    const { classes, isMobile } = this.props

    return (
      <Fragment>
        <Button
          variant="flat"
          disableFocusRipple
          className={classes.button}
          onClick={this.handleOpen}
        >
          {isMobile && <Typography variant="caption">{this.label}</Typography>}
          {!isMobile && <Typography>{this.label}</Typography>}
        </Button>

        <Dialog onClose={this.handleClose} open={this.isOpen}>
          <List>
            {this.options.map((item) => (
              <ListItem
                button
                onClick={() => this.handleListItemClick(item)}
                key={item.key}
              >
                <ListItemText primary={item.value} />
              </ListItem>
            ))}
          </List>
        </Dialog>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Direction.js